export default "__VITE_PUBLIC_ASSET__695a9e76__"